import { render, staticRenderFns } from "./dashboard-block.vue?vue&type=template&id=22c8929c"
import script from "./dashboard-block.vue?vue&type=script&lang=js"
export * from "./dashboard-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports